import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

/**
 * Specialist pilot entry card — used on Home, Plans and For Tradies pages
 * to promote the Energy Growth Pilot and Installer Growth Pilot side-by-side.
 */
export default function PilotCard({
  label,
  title,
  description,
  ctaLabel,
  ctaTo,
  variant = "light",
  testId,
}) {
  const isDark = variant === "dark";
  return (
    <Link
      to={ctaTo}
      data-testid={testId}
      className={
        "group relative flex flex-col h-full rounded-[1.75rem] border-2 p-7 md:p-8 transition-all duration-300 hover:-translate-y-1 " +
        (isDark
          ? "bg-forest border-forest text-white hover:border-lime"
          : "bg-white border-border-neutral text-forest hover:border-mint")
      }
    >
      <div className="flex items-center gap-2">
        <span
          className={
            "inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-bold uppercase tracking-[0.15em] " +
            (isDark ? "bg-white/10 text-lime" : "bg-soft text-mint")
          }
        >
          <Sparkles className="h-3 w-3" />
          {label}
        </span>
      </div>
      <h3
        className={
          "mt-5 text-2xl md:text-[1.75rem] font-extrabold leading-tight " +
          (isDark ? "text-white" : "text-forest")
        }
      >
        {title}
      </h3>
      <p
        className={
          "mt-4 leading-relaxed flex-1 " +
          (isDark ? "text-white/75" : "text-mid-neutral")
        }
      >
        {description}
      </p>
      <div
        className={
          "mt-6 inline-flex items-center gap-2 text-sm font-bold " +
          (isDark ? "text-lime" : "text-forest")
        }
      >
        {ctaLabel}
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </div>
    </Link>
  );
}
